export default "__VITE_ASSET__8715eff2__"